import { Save } from '@mui/icons-material';
import { Box, Button, Dialog, TextField } from '@mui/material';
import { useState } from 'react';

export type chatData = {
		comentario: string;
		arquivo?: File;
}
interface NewChatProps {
    open: boolean;
    close: () => void;
		handleSave: (data: chatData) => void,
}

export default function NewChat({ close, open, handleSave }: NewChatProps) {

    const [value, setValue] = useState<chatData>({
        comentario: '',
        arquivo: undefined,
    });

    const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setValue({ ...value, arquivo: file });
        }
    };

		function onSave() {
			handleSave(value);
			setValue({comentario: '', arquivo: undefined});
		}

    return (
        <Dialog
            open={open}
            onClose={close}
            sx={{ borderRadius: '25px' }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2, gap: 2 }}>
                <TextField
                    label='Mensagem'
                    multiline
                    fullWidth
                    rows={5}
                    required
                    onChange={(e) => setValue({ ...value, comentario: e.target.value })}
                    value={value.comentario}
                />
                <TextField
                    type='file'
                    fullWidth
                    onChange={onFileChange}
                    inputProps={{ accept: '.pdf, .jpg, .png' }}
                    sx={{
                        '& ::file-selector-button': {
                            backgroundColor: (theme) => theme.palette.primary.main,
                            color: (theme) => theme.palette.getContrastText(theme.palette.primary.main),
                            borderRadius: '25px',
                            border: 'none',
                            padding: '5px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                        },
                    }}
                />
                <Button startIcon={<Save />} variant='contained' onClick={onSave}>Salvar</Button>
            </Box>
        </Dialog>
    );
}